var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { generatePromises } from "../generators/generator.promises";
import { addEnabledAccountStart, removeEnabledAccountStart, useEnabledAccountStart, } from "./enabledAccount.actions";
import { GENERATOR_PARAMS } from "./enabledAccount.constants";
export var getPaged = (_a = generatePromises(GENERATOR_PARAMS), _a.getPaged), getCount = _a.getCount;
export var add = function (dispatch, payload) {
    return new Promise(function (resolve, reject) {
        dispatch(addEnabledAccountStart.getAction(__assign(__assign({}, payload), { onSuccess: function () { return resolve(); }, onFailure: function (error) { return reject(error); } })));
    });
};
export var remove = function (dispatch, payload) {
    return new Promise(function (resolve, reject) {
        dispatch(removeEnabledAccountStart.getAction(__assign(__assign({}, payload), { onSuccess: function () { return resolve(); }, onFailure: function (error) { return reject(error); } })));
    });
};
export var use = function (dispatch, payload) {
    return new Promise(function (resolve, reject) {
        dispatch(useEnabledAccountStart.getAction(__assign(__assign({}, payload), { onSuccess: function (tokens) { return resolve(tokens); }, onFailure: function (error) { return reject(error); } })));
    });
};
